import $ from "jquery";
import cookie from "js-cookie";
import qs from "query-string";
import _ from "lodash";

import config from "./config";

// should be pulled from build?
const INDEED_KEY = "SJNE94KB4C";

function canTrack(groupId) {
    return (
        window.OneTrust &&
        window.OnetrustActiveGroups &&
        window.OnetrustActiveGroups.includes(groupId)
    );
}

function track(category, event) {
    if (window.ga && canTrack("C0002")) {
        window.ga("send", "event", {
            eventCategory: category,
            eventAction: event,
        });
    }

    if (window.fbq && category !== "ERROR" && canTrack("C0004")) {
        window.fbq("track", "ViewContent", {
            content_name: event,
            content_category: category,
        });
    }

    if (!config.IS_PROD) {
        /* eslint-disable no-console */
        console.log("[track]", category, event);
        /* eslint-enable */
    }
}

function trackVirtualPage(page) {
    if (window.ga && canTrack("C0002")) {
        window.ga("set", "page", page);
        window.ga("send", "pageview");
    }
}

function trackLoginEvent(name) {
    const url = window.location.pathname + window.location.search;
    let category = "LOGIN_CAND";

    if (url.indexOf("start") > -1) {
        category = "LOGIN_CAND_APP";
    } else if (url.indexOf("portal") > -1) {
        category = "LOGIN_HM";
    }

    track(category, name);
}

function sendConversion(label, property = "AW-871725168") {
    if (!window.gtag) {
        return;
    }

    if (canTrack("C0004")) {
        // Fire AdWords conversion tracking pixel
        window.gtag("event", "conversion", { send_to: `${property}/${label}` });
    }
}

function trackAppSession() {
    // Tracks a "group" of at least one passing app, at most once an hour
    const cookieKey = "_app_session_cookie";
    if (cookie.get(cookieKey)) {
        return;
    }

    trackTalroo();
    sendConversion("lVlCCO_HmoUBEPDw1Z8D"); // AdWords: Session
    if (window.fbq && canTrack("C0004")) {
        window.fbq("track", "InitiateCheckout");
    }

    cookie.set(cookieKey, 1, { expires: 1 / 24 }); // 1 hour
}

function trackPassingApp() {
    sendConversion("vRBTCKC0moUBEPDw1Z8D"); // AdWords: Passing
    if (window.fbq && canTrack("C0004")) {
        window.fbq("track", "Purchase");
    }
}

function trackNewApp() {
    // We rely on a cookie set from the backend to tell us whether
    // these pixels should fire
    if (!cookie.get("pdnw_app")) {
        return;
    }
    cookie.remove("pdnw_app");

    const source = cookie.get("pdnw_source") || "";
    if (source === "in" || source === "in-targeted") {
        trackIndeed();
    } else if (source === "in2") {
        trackIndeed2("recordApply");
    } else if (source === "google") {
        trackGoogle();
    } else if (source === "rx") {
        trackRecruitics("apply");
    } else {
        return;
    }

    // We've fired a conversion pixel at this point, so we "disable" additional
    // conversions for this source for an hour by prepending an underscore
    cookie.remove("pdnw_source");
    cookie.set("pdnw_source", `_${source}`, { expires: 1 / 24 }); // 1 hour
}

/*
 * The analog of trackIndeed for AdWords campaigns
 */
function trackGoogle() {
    if (config.IS_PROD && canTrack("C0004")) {
        sendConversion("48RvCJmevo8BEPDw1Z8D"); // AdWords: Applications Started
    }
    track("PARTNER", "GOOGLE");
}

function trackPando(triggerName) {
    if (!(config.IS_PROD && canTrack("C0004"))) {
        return;
    }

    const source = cookie.get("pdnw_source") || "";
    if (source !== "pando") {
        return;
    }

    const o = document.createElement("script");
    const s = document.getElementsByTagName("script")[0];
    o.src = "//tracking.pandoiq.com/9664";
    s.parentNode.insertBefore(o, s);

    if (triggerName === "apply") {
        // We've fired a conversion pixel at this point, so we "disable" additional
        // conversions for this source for an hour by prepending an underscore
        cookie.remove("pdnw_source");
        cookie.set("pdnw_source", `_${source}`, { expires: 1 / 24 }); // 1 hour
    }
}

function trackRecruitics(triggerName) {
    if (!(config.IS_PROD && canTrack("C0004"))) {
        return;
    }

    if (!window.rx) {
        const o = document.createElement("script");
        const s = document.getElementsByTagName("script")[0];
        o.src = "//jsv3.recruitics.com/55a08e8a-3395-11e9-88cd-6fe50e4cbe9b.js";
        o.addEventListener(
            "load",
            () => {
                trackRecruitics(triggerName);
            },
            false,
        );
        s.parentNode.insertBefore(o, s);
        return;
    }

    const jobId = _findJobId();

    if (jobId) {
        // Recruitics setup takes a second?
        setTimeout(() => {
            window.rx.trigger({
                triggerName,
                jobId,
            });
        }, 150);
    }
}

function trackTalroo() {
    // cannot track if consent not granted
    if (!canTrack("C0004")) {
        return;
    }

    const utm = cookie.get("utm") ? qs.parse(cookie.get("utm")) : {};
    if (utm.utm_source !== "talroo") {
        return;
    }

    let url = "//www.jobs2careers.com/conversion3.php?p=5842&_rn=";
    url += Math.round(Math.random() * 10000000000);

    if (config.IS_PROD) {
        const pixel = new Image();
        pixel.src = url;
    }

    track("PARTNER", "TALROO");
}

function trackIndeed() {
    // cannot track if consent not granted
    if (!canTrack("C0004")) {
        return;
    }
    let url = "//conv.indeed.com/pagead/conv/4824809487161189/?rand=";
    url += Math.round(Math.random() * 10000000000);

    if (config.IS_PROD) {
        const pixel = new Image();
        pixel.src = url;
    }

    track("PARTNER", "INDEED");
}

function _findJobId() {
    const jobId = window.positions && window.positions.length && window.positions[0].id;
    return jobId || $(".position-detail.featured").data("id");
}

function trackIndeed2(mode = "recordLanding") {
    // cannot track if consent not granted
    if (!canTrack("C0004")) {
        return;
    }

    // send only test/dummy data in non-prod
    const testFire = !config.IS_PROD;
    // create actual tracking function
    const doTrack = () => {
        const jobId = _findJobId();
        const data = { jobId, testFire };
        window.ict(mode, data);
    };
    // check if we've tried to load the script
    if (!window.ict_loaded) {
        // if not, load it
        const o = document.createElement("script");
        o.src = "https://convcdn.indeed.tech/ld-min.js";
        const s = document.getElementsByTagName("script")[0];
        o.addEventListener(
            "load",
            () => {
                window.indeed_q = window.indeed_q || [];
                window.ict = window.ict || (({ ...args }) => window.indeed_q.push(...args));
                window.ict("init", INDEED_KEY);
                doTrack();
            },
            false,
        );
        s.parentNode.insertBefore(o, s);
        window.ict_loaded = true;
    } else {
        // if so, attempt to use loaded script
        // if we anticipate multiple calls on pageload, this can be wrapped in a timeout
        doTrack();
    }
}

function trackDrip(data, tags) {
    if (!(window._dcq && canTrack("C0004"))) return;

    const defaults = {};
    if (window.user) {
        const { firstName, email } = window.user;

        if (firstName) {
            defaults.first_name = firstName;
        }

        if (email) {
            defaults.email = email;
        }
    }

    data = _.defaults(data, {
        ...defaults,
        tags: ["production"].concat(tags || []),
    });

    window._dcq.push(["identify", data]);
}

function trackStep(name) {
    let category = "APP";
    if (!window.authUser) {
        category = `${category}_FIRST`;
    }
    track(category, name);
    trackVirtualPage(`/app/${name.toLowerCase()}`);
}

export default {
    track,
    trackLoginEvent,
    trackVirtualPage,
    trackIndeed,
    trackIndeed2,
    trackRecruitics,
    trackPando,
    trackDrip,
    sendConversion,
    trackAppSession,
    trackPassingApp,
    trackNewApp,
    trackStep,
};
